import { createRoute } from '@tanstack/react-router';
import { StockOverview } from '@/features/stock/StockOverview';
import { Route as shellRoute } from '../_shell';

/** Stock overview. One row per physical SKU, grouped by family. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock',
  component: StockOverview,
});
